// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import "@/assets/css/default.css"
import "@/assets/css/animate.css"
import "@/assets/js/jquery-3.4.1.min.js"
import promise from 'es6-promise';

Vue.config.productionTip = false
Vue.prototype.$http = axios
promise.polyfill()
Vue.use(ElementUI);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js